module.exports = __webpack_public_path__ + "img/logo-dark.d52f6158.png";